/* SUPPLI-X: Produktbilder wechseln beim Scrollen mit dem Text rechts.
   Nur Desktop/Tablet (ab 750 px, dort steht die Galerie sticky neben dem Text).
   Bild 1 oben, letztes Bild wenn der Text unten ankommt; Videos/3D werden übersprungen.
   Sobald der Kunde selbst ein Bild wählt (Vorschaubild, Pfeile, Variante), bleibt der
   automatische Wechsel für diesen Seitenaufruf aus. Bei "weniger Bewegung" nie aktiv. */
(function () {
  var mqDesktop = window.matchMedia('(min-width: 750px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(gallery) {
    if (gallery.dataset.sxScroll) return;
    if (gallery.closest('quick-add-modal')) return;
    if (!(gallery.dataset.desktopLayout || '').includes('thumbnail')) return;
    var section = gallery.closest('.sx-pdp');
    var info = section && section.querySelector('.product__info-wrapper');
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!info || !viewer) return;
    var items = Array.prototype.filter.call(viewer.querySelectorAll('.product__media-item[data-media-id]'), function (el) {
      return !el.classList.contains('product__media-item--full');
    });
    if (items.length < 2) return;
    gallery.dataset.sxScroll = '1';

    var userChose = false;
    var current = -1;
    var ticking = false;

    function stop() { userChose = true; }
    if (thumbs) thumbs.addEventListener('click', function (e) { if (e.target.closest('button')) stop(); });
    viewer.addEventListener('click', function (e) { if (e.target.closest('.slider-button')) stop(); });
    section.addEventListener('change', function (e) { if (e.target.closest('variant-selects, variant-radios')) stop(); });

    function show(i) {
      if (i === current) return;
      current = i;
      var el = items[i];
      if (el.classList.contains('is-active')) return;
      viewer.querySelectorAll('.product__media-item[data-media-id]').forEach(function (m) { m.classList.remove('is-active'); });
      el.classList.add('is-active');
      if (el.animate) el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 350, easing: 'ease-out' });
      if (thumbs && gallery.setActiveThumbnail) {
        var t = thumbs.querySelector('[data-target="' + el.dataset.mediaId + '"]');
        if (t) gallery.setActiveThumbnail(t);
      }
    }

    function update() {
      ticking = false;
      if (userChose || !mqDesktop.matches || mqReduce.matches) return;
      var r = info.getBoundingClientRect();
      var range = r.height - window.innerHeight;
      if (range <= 0) return;
      var p = Math.min(1, Math.max(0, -r.top / range));
      show(Math.min(items.length - 1, Math.floor(p * items.length)));
    }

    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  function start() {
    document.querySelectorAll('.sx-pdp media-gallery').forEach(function (g) {
      if (customElements.get('media-gallery')) init(g);
      else customElements.whenDefined('media-gallery').then(function () { init(g); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
